import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type AddTripBookingMutationVariables = Types.Exact<{
  payload: Types.AddTripBookingRequest;
}>;

export type AddTripBookingMutation = { __typename?: 'Mutation'; addTripBooking: { __typename?: 'TripBooking'; id: string } };

export type TripBookingsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  boardId: Types.Scalars['ID'];
}>;

export type TripBookingsQuery = {
  __typename?: 'Query';
  tripBookings: Array<{
    __typename?: 'TripBooking';
    id: string;
    tripSaveId?: string | null;
    kind: Types.TripBookingKind;
    reservationId: string;
    createdAt: any;
    reservation?: { __typename?: 'TripBookingReservation'; state: Types.TripBookingState; startDate?: string | null; endDate?: string | null } | null;
  }>;
};

export const AddTripBookingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTripBooking' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddTripBookingRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTripBooking' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddTripBookingMutationFn = Apollo.MutationFunction<AddTripBookingMutation, AddTripBookingMutationVariables>;

/**
 * __useAddTripBookingMutation__
 *
 * To run a mutation, you first call `useAddTripBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTripBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTripBookingMutation, { data, loading, error }] = useAddTripBookingMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddTripBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTripBookingMutation, AddTripBookingMutationVariables>) {
  return ApolloReactHooks.useMutation<AddTripBookingMutation, AddTripBookingMutationVariables>(AddTripBookingDocument, baseOptions);
}
export type AddTripBookingMutationHookResult = ReturnType<typeof useAddTripBookingMutation>;
export type AddTripBookingMutationResult = Apollo.MutationResult<AddTripBookingMutation>;
export type AddTripBookingMutationOptions = Apollo.BaseMutationOptions<AddTripBookingMutation, AddTripBookingMutationVariables>;
export const TripBookingsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TripBookings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'boardId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripBookings' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'boardId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'boardId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tripSaveId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reservationId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reservation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTripBookingsQuery__
 *
 * To run a query within a React component, call `useTripBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripBookingsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useTripBookingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TripBookingsQuery, TripBookingsQueryVariables>) {
  return ApolloReactHooks.useQuery<TripBookingsQuery, TripBookingsQueryVariables>(TripBookingsDocument, baseOptions);
}
export function useTripBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TripBookingsQuery, TripBookingsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<TripBookingsQuery, TripBookingsQueryVariables>(TripBookingsDocument, baseOptions);
}
export type TripBookingsQueryHookResult = ReturnType<typeof useTripBookingsQuery>;
export type TripBookingsLazyQueryHookResult = ReturnType<typeof useTripBookingsLazyQuery>;
export type TripBookingsQueryResult = Apollo.QueryResult<TripBookingsQuery, TripBookingsQueryVariables>;
